// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-typed-collection-item {
    display: flex;
    align-items: flex-start;
}

.form-typed-collection-item-add {
    outline: none;
    text-align: center;
    color: #721c24;
    width: 20px;
    height: 59px;
    border: 0;
    background-color: white;
    padding: 0 20px 0 5px;
}

.form-typed-collection-item-type {
    padding: 10px;
    margin: 0 10px;
    text-align: center;
    width: 60px;
    height: 59px;
    background-color: #efefef;
    border-radius: 3px;
}

.form-typed-collection-item-type.textOnly {
    font-size:12px;
    margin: 0 10px;
    padding-top: 20px;
    text-align: center;
    width: 275px;
    height: 59px;
    background-color: #efefef;
    border-radius: 3px;
    display: flex;
    align-items: center;
}

.form-typed-collection-item-type.textOnly p {
    width: 100%;
}

.form-typed-collection-item-type i {
    font-size: 40px;
    width: 50px;
    margin: 0 -5px;
    text-align: center;
}

.form-typed-collection-item-type .icon {
    height: 35px;
    display: block;
    margin-left: auto;
    margin-right: auto;
    max-width: 40px;
}

.form-typed-collection-item-type svg {
    height: 35px;
    display: block;
    margin-left: auto;
    margin-right: auto;
    max-width: 40px;
}
`, "",{"version":3,"sources":["webpack://./src/components/form/TypedCollectionItem.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,YAAY;IACZ,SAAS;IACT,uBAAuB;IACvB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;IACf,WAAW;IACX,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;AACnB","sourcesContent":[".form-typed-collection-item {\n    display: flex;\n    align-items: flex-start;\n}\n\n.form-typed-collection-item-add {\n    outline: none;\n    text-align: center;\n    color: #721c24;\n    width: 20px;\n    height: 59px;\n    border: 0;\n    background-color: white;\n    padding: 0 20px 0 5px;\n}\n\n.form-typed-collection-item-type {\n    padding: 10px;\n    margin: 0 10px;\n    text-align: center;\n    width: 60px;\n    height: 59px;\n    background-color: #efefef;\n    border-radius: 3px;\n}\n\n.form-typed-collection-item-type.textOnly {\n    font-size:12px;\n    margin: 0 10px;\n    padding-top: 20px;\n    text-align: center;\n    width: 275px;\n    height: 59px;\n    background-color: #efefef;\n    border-radius: 3px;\n    display: flex;\n    align-items: center;\n}\n\n.form-typed-collection-item-type.textOnly p {\n    width: 100%;\n}\n\n.form-typed-collection-item-type i {\n    font-size: 40px;\n    width: 50px;\n    margin: 0 -5px;\n    text-align: center;\n}\n\n.form-typed-collection-item-type .icon {\n    height: 35px;\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n    max-width: 40px;\n}\n\n.form-typed-collection-item-type svg {\n    height: 35px;\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n    max-width: 40px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
